import { render, staticRenderFns } from "./shopshare.vue?vue&type=template&id=66dc357e&scoped=true&"
import script from "./shopshare.vue?vue&type=script&lang=js&"
export * from "./shopshare.vue?vue&type=script&lang=js&"
import style0 from "./shopshare.vue?vue&type=style&index=0&id=66dc357e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc357e",
  null
  
)

export default component.exports